import { useState, useEffect, useContext } from 'react'
import { useConfirm } from 'material-ui-confirm'
import { Context } from '../../../utils/context'
import { Strings } from '../../../assets/res/en'
import { groupsEndPoints, merchantsEndPoints } from '../../../utils/endpoints'
import useTableIcons from '../../useTableIcons'
import { format } from 'react-string-format'
import useCommonMenus from '../common/useCommonMenus'
import telephonesDataColumn from '../../../dataColumns/telephonesDataColumn'
import emailsDataColumn from '../../../dataColumns/emailsDataColumn'
import { modules } from '../../../utils/config'

let telephoneValues = [], emailValues = []
function useLocations() {
    const confirm = useConfirm()
    const { axios, authData, permissions } = useContext(Context)
    const authToken = `Bearer ${authData.token}`
    const [locationPermission, setLocationPermission] = useState({})
    const [locations, setLocations] = useState([])
    const [slocations, setSearchLocations] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [modalHeader, setModalHeader] = useState({})
    const [modalContent, setModalContent] = useState({})
    const [modalActions, setModalActions] = useState([])
    const [modalFormResetKeys, setModalFormResetKeys] = useState([])
    const [modalTaskRunning, setModalTaskRunning] = useState(false)
    const [modalFormError, setModalFormError] = useState({})
    const [groupsMenus, setGroupMenus] = useState([])
    const [searchData, setSearchData] = useState({
        sGroup: 1,
        sLocation: ''
    })
    const [filters, setFilters] = useState([])
    const [openDialog, setOpenDialog] = useState(false)
    const [telephoneData, setTelephoneData] = useState([])
    const [emailData, setEmailData] = useState([])
    const { currencyCodeMenus, countryMenus, stateMenus, telephoneTypeMenus } = useCommonMenus()
    const { tableIcons } = useTableIcons()
    const { teleCols } = telephonesDataColumn(telephoneTypeMenus)
    const { emailCols } = emailsDataColumn()
    //check permission changes
    useEffect(() => {
        if (permissions && permissions.length > 0) {
            let locPermission = permissions.find(p => p.moduleId === modules.locations.id)
            setLocationPermission(locPermission)
        }
    }, [permissions])
    //get Groups
    useEffect(() => {
        axios.get(groupsEndPoints.getAll,
            { headers: { 'Authorization': authToken } })
            .then(res => {
                if (res.data.success) {
                    const { data } = res.data
                    const groupItems = data.map(g => ({
                        text: g.description,
                        val: g.idGroup
                    })).sort((a, b) => (a.text ?? "").localeCompare(b.text ?? ""))
                    setGroupMenus(groupItems)

                    const firstGroup = groupItems[0]?.val
                    setSearchData(prevData => ({
                        ...prevData,
                        sGroup: firstGroup
                    }))
                    setFilters([
                        {
                            name: "sGroup",
                            value: groupItems.find(g => g.val === firstGroup)?.text ?? "",
                            isRemovable: false
                        }
                    ])
                }
            })
            .catch(err => err)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //get Locations On Group Chnage
    useEffect(() => {
        getLocationsAll()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchData.sGroup])

    const updateQRMerchant = async(id_group, id_merchant, data) => {
        let response = null
        try {
        response = await axios.put(`/merchant/${id_group}/${id_merchant}/cmsData`, data, { headers: { Authorization: authToken } })
        } catch (error) {
        console.log('ERROR: Update QR Merchant', error)
        }
        return response
    }

    const getLocationsAll = () => {
        setSearchData(prevData => ({
            ...prevData,
            sLocation: ''
        }))
        if (searchData.sGroup > 0) {
            let merchantByGroupId = `${merchantsEndPoints.getMerchantByGroupID}/${searchData.sGroup}`
            setIsLoading(true)
            axios.get(merchantByGroupId,
                { headers: { 'Authorization': authToken } })
                .then(res => {
                    if (res.status === 200) {
                        const { data } = res.data
                        setLocations(data)
                        setSearchLocations(data)
                        //set filter
                        setFilters([
                            {
                                name: "sGroup",
                                value: groupsMenus.find(g => g.val === searchData["sGroup"]).text,
                                isRemovable: false
                            }
                        ])
                    }
                })
                .catch(err => err)
                .finally(() => setIsLoading(false))
        }
    }
    const actions = [
        rowData => ({
            icon: rowData.status === 0 ? tableIcons.CheckBoxBlank : tableIcons.CheckBox,
            tooltip: locationPermission.update ? rowData.status === 0 ? 'Activate this Location' : 'Deactivate this Location' : 'Permission Denied',
            disabled: !locationPermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                let cnfDesc = rowData.status === 0 ? `This will activate location ${rowData.description ?? ""}` :
                    `This will deactivate location ${rowData.description ?? ""}`
                confirm({ description: cnfDesc })
                    .then(() => {
                        let url = rowData.status === 0 ? merchantsEndPoints.activateMerchantById : merchantsEndPoints.deActivateMerchantById

                        let params = {
                            idGroup: rowData.idGroup,
                            idMerchant: rowData.idMerchant
                        }
                        axios.put(
                            url,
                            params,
                            { headers: { 'Authorization': authToken } })
                            .then(res => {
                                if (res.status === 200) {
                                    const dataUpdate = [...locations]
                                    const index = rowData.tableData.id
                                    dataUpdate[index] = res.data.data.merchant
                                    setLocations([...dataUpdate])
                                    resolve()
                                }
                            })
                    })
            })
        }),
        {
            icon: tableIcons.Edit,
            tooltip: locationPermission.update ? 'Edit Location' : 'Permission Denied',
            disabled: !locationPermission.update,
            onClick: (event, rowData) => new Promise((resolve) => {
                setIsLoading(true)
                setModalFormResetKeys([])
                let url = format(merchantsEndPoints.getMerchantByMerchantId, rowData.idGroup, rowData.idMerchant)
                axios.get(url,
                    { headers: { 'Authorization': authToken } })
                    .then(res => {
                        if (res.status === 200) {
                            const { data } = res.data
                            resolve(data)
                        }
                    })
                    .catch(err => err)
                    .finally(() => setIsLoading(false))
            }).then((data) => handleActionClick(event, true, data))
        },
        {
            icon: tableIcons.View,
            tooltip: 'View Details of this location',
            onClick: (event, rowData) => new Promise((resolve) => {
                setIsLoading(true)
                setModalFormResetKeys([])
                let url = format(merchantsEndPoints.getMerchantByMerchantId, rowData.idGroup, rowData.idMerchant)
                axios.get(url,
                    { headers: { 'Authorization': authToken } })
                    .then(res => {
                        if (res.status === 200) {
                            const { data } = res.data
                            resolve(data)
                        }
                    })
                    .catch(err => err)
                    .finally(() => setIsLoading(false))
            }).then((data) => handleActionClick(event, false, data, true))
        }
    ]
    const handleChange = (name, value) => {
        setSearchData(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    const resetData = () => {
        setSearchData(prevData => ({
            ...prevData,
            sLocation: ''
        }))
        setFilters([
            {
                name: "sGroup",
                value: groupsMenus.find(g => g.val === searchData["sGroup"]).text,
                isRemovable: false
            }
        ])
        getLocationsAll()
    }

    const handleSearch = () => {
        let searchFilter = searchData.sLocation.trim()
        if (searchFilter) {
            setFilters([
                {
                    name: "sGroup",
                    value: groupsMenus.find(g => g.val === searchData["sGroup"]).text,
                    isRemovable: false
                },
                {
                    name: "sLocation",
                    value: searchFilter,
                    isRemovable: true,
                    remove: resetData
                }
            ])
            setLocations(slocations.filter(l => l?.description?.toLowerCase()?.includes(searchFilter.toLowerCase())))
        }
        else resetData()
    }

    const searchOptions = {
        title: Strings.SEARCH_LOCATIONS_TITLE,
        spacing: 2,
        searchItems: [
            {
                name: "sGroup",
                label: Strings.SEARCH_CASINO_GROUP,
                isSelect: true,
                menuItems: groupsMenus,
                defaultValue: searchData["sGroup"],   // antes: 1
                onChange: handleChange
            },
            {
                name: "sLocation",
                label: Strings.SEARCH_LOCATIONS_TITLE,
                type: 'search',
                defaultValue: searchData["sLocation"],
                onChange: handleChange
            }
        ],
        handleSearch
    }
    //#region Modal
    const telEditOptions = {
        onRowAdd: newData =>
            new Promise((resolve, reject) => {
                setTelephoneData(prevData => [...prevData, newData])
                resolve()
            }),
        onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
                const index = oldData.tableData.id
                setTelephoneData(prevData => prevData.map((item, ix) => {
                    if (ix === index) return newData
                    return item
                }))
                resolve()
            }),
        onRowDelete: oldData =>
            new Promise((resolve, reject) => {
                const index = oldData.tableData.id
                setTelephoneData(prevData => prevData.filter((item, ix) => ix !== index))
                resolve()
            })
    }
    const mailEditOptions = {
        onRowAdd: newData =>
            new Promise((resolve, reject) => {
                setEmailData(prevData => [...prevData, newData])
                resolve()
            }),
        onRowUpdate: (newData, oldData) =>
            new Promise((resolve, reject) => {
                const index = oldData.tableData.id
                setEmailData(prevData => prevData.map((item, ix) => {
                    if (ix === index) return newData
                    return item
                }))
                resolve()
            }),
        onRowDelete: oldData =>
            new Promise((resolve, reject) => {
                const index = oldData.tableData.id
                setEmailData(prevData => prevData.filter((item, ix) => ix !== index))
                resolve()
            })
    }
    useEffect(() => {
        new Promise(resolve => {
            setModalFormResetKeys(["telephones", "emails"])
            telephoneValues = telephoneData ?? []
            emailValues = emailData ?? []
            resolve()
        }).then(() =>
            setModalContent(prevContent => ({
                ...prevContent,
                telephones: {
                    ...prevContent["telephones"],
                    data: telephoneData
                },
                emails: {
                    ...prevContent["emails"],
                    data: emailData
                }
            }))
        )
    }, [telephoneData, emailData])
    const handleSubmit = (data, isEdit, rowData) => {
        setModalTaskRunning(true)
        const {
            betweenStreets,
            city,
            comment,
            description,
            shortDescription,
            // idAddressType,
            idCountry,
            idCurrencyCode,
            idGroup,
            idState,
            interior,
            number,
            street,
            zipCode
        } = data
        const postData = {
            "merchant": {
                "idGroup": idGroup,
                "idMerchant": rowData?.merchant?.idMerchant ?? 0,
                "description": description,
                "shortDescription":shortDescription,
                "idCurrencyCode": idCurrencyCode
            },
            "address": {
                // "idAddressType": idAddressType,
                "idCountry": idCountry,
                "idState": idState,
                "zipCode": zipCode,
                "street": street,
                "number": number,
                "interior": interior,
                "city": city,
                "betweenStreets": betweenStreets,
                "comment": comment,
                "preferred": true
            },
            "telephones": (telephoneValues && telephoneValues.length > 0) ? telephoneValues.map(t => ({
                "idPhoneType": t.idPhoneType,
                "phoneNumber": t.phoneNumber,
                "preferred": t.preferred
            })) : [],
            "emails": (emailValues && emailValues.length > 0) ? emailValues.map(e => ({
                "emailValue": e.emailValue,
                "preferred": e.preferred
            })) : []
        }
        axios({
            method: isEdit === true ? 'put' : 'post',
            url: merchantsEndPoints.addEditMerchant,
            headers: { 'Authorization': authToken },
            data: postData
        }).then((res) => {
            const response = res.data
            //todo change checking to response.success after API rectification
            if (res.status === 200) {
                handleModalClose()
                getLocationsAll()
            }
            else
                setModalFormError(response.errors)
        })
            .catch(err => err)
            .finally(() => setModalTaskRunning(false))
    }
    const handleSelectionChange = (event) => {
        const idCountry = event.target.value
        new Promise(resolve => {
            setModalFormResetKeys(["idState"])
            resolve()
        }).then(() =>
            setModalContent(prevContent => ({
                ...prevContent,
                idState: {
                    ...prevContent["idState"],
                    value: '',
                    menuItems: stateMenus.filter(s => s.idCountry === idCountry)
                }
            }))
        )
    }
    const handleModalClose = () => {
        telephoneValues = []
        emailValues = []
        setOpenDialog(false)
        setModalFormError({})
        setModalFormResetKeys([])
        setTelephoneData([])
        setEmailData([])
    }
    const handleActionClick = (event, isEdit = false, rowData = {}, isReadOnly = false) => {
        const { merchant, address, telephones, emails } = rowData
        setModalHeader({
            isForm: true,
            title: isEdit === true ? "Edit Location" : isReadOnly === true && "View Location Details" || "Add Location",
            header: isEdit === true ? "Edit this existing Location" : isReadOnly === true && "Location Details" || "Create a new Location",
            modalWidth: 'md',
            isReadOnly: isReadOnly
        })
        setModalContent({
            description: {
                label: "Description",
                size: "small",
                variant: "outlined",
                col: 12,
                value: merchant?.description ?? "",
                validator: {
                    required: { value: true, message: "Description is required" }
                }
            },
            shortDescription: {
                label: "IVR Description",
                size: "small",
                variant: "outlined",
                col: 12,
                value: merchant?.shortDescription ?? "",
                validator: {
                    required: { value: false, message: "IVR Description is required" }
                }
            },
            idGroup: {
                label: "Group",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: merchant?.idGroup ?? '',
                menuItems: groupsMenus,
                validator: {
                    required: { value: true, message: "Please choose a Group" }
                }
            },
            idCurrencyCode: {
                label: "Currency Code",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: merchant?.idCurrencyCode ?? "",
                menuItems: currencyCodeMenus,
                validator: {
                    required: { value: true, message: "Currency Code is required" }
                }
            },
            idCountry: {
                label: "Country",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.idCountry ?? "",
                menuItems: countryMenus,
                validator: {
                    required: { value: true, message: "Please choose a Country" }
                },
                onSelectionChange: handleSelectionChange
            },
            idState: {
                label: "State",
                type: 'select',
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.idState ?? "",
                menuItems: stateMenus.filter(s => s.idCountry === (address?.idCountry ?? "")),
                validator: {
                    required: { value: true, message: "Please choose a State" }
                }
            },
            zipCode: {
                label: "Zip Code",
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.zipCode ?? "",
                validator: {
                    required: { value: true, message: "Zip Code is required" }
                }
            },
            street: {
                label: "Street",
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.street ?? "",
                validator: {
                    required: { value: true, message: "Street is required" }
                }
            },
            number: {
                label: "Number",
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.number ?? "",
                validator: {
                    required: { value: true, message: "Number is required" }
                }
            },
            interior: {
                label: "Interior",
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.interior ?? ""
            },
            city: {
                label: "City",
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.city ?? "",
                validator: {
                    required: { value: true, message: "City is required" }
                }
            },
            betweenStreets: {
                label: "Between Streets",
                size: "small",
                variant: "outlined",
                col: 6,
                value: address?.betweenStreets ?? ""
            },
            comment: {
                label: "Comment",
                size: "small",
                variant: "outlined",
                col: 12,
                value: address?.comment ?? ""
            },
            telephones: {
                label: "Telephones",
                type: 'table',
                col: 12,
                columns: teleCols,
                editable: isReadOnly ? {} : telEditOptions,
                data: telephoneData
            },
            emails: {
                label: "Emails",
                type: 'table',
                col: 12,
                columns: emailCols,
                editable: isReadOnly ? {} : mailEditOptions,
                data: emailData
            }
        })
        setOpenDialog(true)
        if (isEdit === true || isReadOnly === true) {
            telephoneValues = telephones ?? []
            emailValues = emails ?? []
            setTelephoneData(telephones ?? [])
            setEmailData(emails ?? [])
        }
        else {
            setModalFormResetKeys([])
        }
        if (isReadOnly)
            setModalActions([])
        else {
            setModalActions([
                {
                    label: isEdit === true ? "Update" : "Save",
                    icon: isEdit === true ? tableIcons.Edit : tableIcons.Save,
                    isSubmit: true,
                    action: isEdit === true ?
                        (data) => handleSubmit(data, true, rowData) :
                        (data) => handleSubmit(data, false)
                }
            ])
        }
    }
    return {
        locations,
        groupsMenus,
        isLoading,
        searchOptions,
        filters,
        openDialog,
        actions,
        handleModalClose,
        handleActionClick,
        modalHeader,
        modalContent,
        modalActions,
        modalFormResetKeys,
        modalTaskRunning,
        modalFormError,
        locationPermission,
        updateQRMerchant
    }
}

export default useLocations;